import React, { useState, useEffect, useRef } from "react"
import orderData from "components/shared/Util/order"

import Input from "components/shared/Inputs/Inputs"
import SearchTable from "components/shared/SearchTable/SearchTable"
import { useNavigate, useParams } from "react-router-dom"

import api from "../../services/api"
import Swal from "sweetalert2"
import { Link } from "react-router-dom"
import {
  Col,
  Card,
  CardBody,
  Container,
  Row,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap"
import Select from "react-select"

import AuthService from "../../services/Auth.service"
import ReactInputMask from "react-input-mask"

import baixo from "../../assets/images/baixo.png"
import cima from "../../assets/images/cima.png"
import inicial from "../../assets/images/inicial.png"
const Condominios = () => {
  const initialState = {
    number: "",
    desc: "",
    model: "",
    status: "",
  }

  const [showRazao, setShowRazao] = useState(false)
  const [userData, setUserData] = useState({})
  const [load, setLoad] = useState(true)
  const [modal, setModal] = useState(false)
  const user = AuthService.getCurrentUser()
  const [validDelete, setValidDelete] = useState(true)
  const [order, setOrder] = useState(0)
  const [orderBy, setOrderBy] = useState("")
  const [password, setPassword] = useState("")
  const [passwordEntered, setPasswordEntered] = useState(false)
  const [search, setSearch] = useState(initialState)
  const [values, setValues] = useState([])
  const [showList, setShowList] = useState(false)
  const [PendingRadioValue, setPendingRadioValue] = useState(null)
  const [data, setData] = useState([])
  const [formattedData, setFormattedData] = useState([])
  const [editedInstallationDate, setEditedInstallationDate] = useState("")

  // Estados para gerenciamento de síndicos
  const [modalSindico, setModalSindico] = useState(false)
  const [selectedCondo, setSelectedCondo] = useState(null)
  const [sindicos, setSindicos] = useState([])
  const [selectedSindico, setSelectedSindico] = useState(null)
  const [sindicosMap, setSindicosMap] = useState({}) // Mapa OID_EMPRESA -> síndico info

  // Verificar se usuário é admin (DS_STATUS = 10)
  const isAdmin = user?.DS_STATUS === 10 || user?.DS_STATUS === "10"

  const tableWrapRef = useRef(null)

  const handlePasswordChange = e => {
    setPassword(e.target.value)
  }

  const handlePasswordSubmit = () => {
    if (password === "token") {
      setPasswordEntered(true)
    } else {
      alert("Senha inválida")
    }
  }

  const changeOrder = key => {
    let ordertpm = 0
    if (key === orderBy) {
      if (order == 1) {
        ordertpm = 2
        setOrder(ordertpm)
      } else {
        ordertpm = 1
        setOrder(ordertpm)
      }
    } else {
      ordertpm = 1
      setOrder(ordertpm)
    }
    setOrderBy(key)
    orderData(filteredShowInfos, key, ordertpm)
  }

  let navigate = useNavigate()

  const toggle = () => setModal(!modal)

  const [modalType, setModalType] = useState("")

  let checkempresa = null
  let razao = null
  if (user != null) {
    if (user.empresa[0] != undefined) {
      checkempresa = user.empresa[0].OID_EMPRESA
      razao = user.empresa[0].NM_RAZAO_SOCIAL
    }
  }

  const statusArray = [
    { id: "", status: "Selecione..." },
    { id: "S", status: "Ativo" },
    { id: "N", status: "Inativo" },
  ]

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/empresa/")
        let arr = formatArray(response.data)
        console.log("Initial formatted array:", arr)
        const updatedArr = await loadInstallationDates(arr)
        console.log("Array after loading installation dates:", updatedArr)
        setData(updatedArr)
        setValues(updatedArr)
        setFormattedData(updatedArr)
        console.log("State setFormattedData called with:", updatedArr)
      } catch (error) {
        console.error("Erro ao carregar dados:", error)
      }
    }
    fetchData()
  }, [])

  // Handle ESC key to exit edit mode
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        setEditModeRow(null)
      }
    }

    window.addEventListener("keydown", handleEscapeKey)

    return () => {
      window.removeEventListener("keydown", handleEscapeKey)
    }
  }, [])

  // Buscar lista de síndicos ao carregar a página (apenas para admin)
  useEffect(() => {
    if (isAdmin) {
      fetchSindicos()
      fetchSindicosMap()
    }
  }, [isAdmin])

  // Função para buscar todos os síndicos disponíveis
  const fetchSindicos = () => {
    api.get("/user/sindicos?limit=1000").then((response) => {
      const options = (response.data.data || []).map(s => ({
        value: s.OID_USUARIO,
        label: `${s.DS_NOME} ${s.DS_SOBRENOME} (${s.DS_EMAIL})`
      }))
      // Adicionar opção "Sem síndico" no início
      options.unshift({ value: null, label: "Sem síndico" })
      setSindicos(options)
    }).catch(err => {
      console.error("Erro ao buscar síndicos:", err)
    })
  }

  // Função para buscar o mapa de síndicos por condomínio
  const fetchSindicosMap = async () => {
    try {
      const response = await api.get("/user/sindicos?limit=1000")
      const sindicosData = response.data.data || []
      
      // Criar mapa: OID_EMPRESA -> síndico info
      const map = {}
      sindicosData.forEach(sindico => {
        if (sindico.condominios && sindico.condominios.length > 0) {
          sindico.condominios.forEach(condo => {
            if (condo && condo.OID_EMPRESA) {
              map[condo.OID_EMPRESA] = {
                OID_USUARIO: sindico.OID_USUARIO,
                nome: `${sindico.DS_NOME} ${sindico.DS_SOBRENOME}`,
                email: sindico.DS_EMAIL
              }
            }
          })
        }
      })
      setSindicosMap(map)
    } catch (err) {
      console.error("Erro ao buscar mapa de síndicos:", err)
    }
  }

  // Abrir modal para gerenciar síndico
  const openSindicoModal = (condo) => {
    setSelectedCondo(condo)
    
    // Verificar se o condomínio já tem síndico vinculado
    const sindicoAtual = sindicosMap[condo.id]
    if (sindicoAtual) {
      const found = sindicos.find(s => s.value === sindicoAtual.OID_USUARIO)
      setSelectedSindico(found || null)
    } else {
      setSelectedSindico({ value: null, label: "Sem síndico" })
    }
    
    setModalSindico(true)
  }

  // Salvar vínculo de síndico
  const saveSindicoVinculo = async () => {
    try {
      const sindicoAtual = sindicosMap[selectedCondo.id]
      const novoSindicoId = selectedSindico?.value
      
      // Se já existe um síndico e estamos trocando para outro (não null)
      if (sindicoAtual && novoSindicoId && sindicoAtual.OID_USUARIO !== novoSindicoId) {
        const result = await Swal.fire({
          title: "Confirmar troca de síndico",
          html: `O condomínio <strong>${selectedCondo.razao}</strong> já possui o síndico <strong>${sindicoAtual.nome}</strong> vinculado.<br><br>Ao continuar, o síndico atual será <strong>desvinculado</strong> deste condomínio e substituído pelo novo síndico selecionado.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, substituir",
          cancelButtonText: "Cancelar"
        })
        
        if (!result.isConfirmed) {
          return
        }
      }
      
      // Atualizar o OID_USUARIO da empresa
      await api.put(`/empresa/${selectedCondo.id}/sindico`, {
        OID_USUARIO: novoSindicoId ? Number(novoSindicoId) : null,
      })
      
      Swal.fire("Sucesso", "Síndico atualizado com sucesso", "success")
      setModalSindico(false)
      
      // Atualizar o mapa de síndicos
      fetchSindicosMap()
      
    } catch (err) {
      console.error("Erro ao atualizar síndico:", err)
      Swal.fire("Erro", "Erro ao atualizar síndico", "error")
    }
  }

  const [filterCondominio, setfilterCondominio] = useState("")
  const [filterEndereco, setfilterEndereco] = useState("")
  let uniqueEmpresas = []

  if (formattedData.length > 0) {
    uniqueEmpresas = [...new Set(formattedData.map(info => info.razao))]
  }

  let uniqueEnd = []

  if (formattedData.length > 0) {
    uniqueEnd = [...new Set(formattedData.map(info => info.endereco))]
  }

  let filteredShowInfos = []

  const normalizeString = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };


  if (formattedData.length > 0) {
    if (filterCondominio.length > 0) {
      if (filterCondominio != "Todos") {
        const normalizedFilter = normalizeString(filterCondominio).toLowerCase();

        filteredShowInfos = formattedData.filter(info =>
          normalizeString(info.razao).toLowerCase().includes(normalizedFilter)
        );
      } else {
        setfilterCondominio("")
        filteredShowInfos = formattedData
      }
    } else if (filterEndereco.length > 0) {
      console.log(filterEndereco)
      if (filterEndereco != "Todos") {
        const normalizedFilter = normalizeString(filterEndereco).toLowerCase();
        filteredShowInfos = formattedData.filter(info =>
          normalizeString(info.endereco).toLowerCase().includes(normalizedFilter)
        )
      } else {
        setfilterEndereco("")
        filteredShowInfos = formattedData
      }
    } else {
      filteredShowInfos = formattedData
    }
  }

  console.log("filteredShowInfos about to render:", filteredShowInfos)

  const onChangeHandler = prop => event => {
    setSearch({ ...search, [prop]: event.target.value })
  }

  const submitHandler = event => {
    event.preventDefault()
    if (!search.number && !search.desc && !search.model && !search.status) {
      Swal.fire({
        icon: "warning",
        text: "Preencha ao menos um campo para fazer uma pesquisa",
      })
      return
    }

    if (!search.number && (search.desc || search.model) && !search.status) {
      Swal.fire({
        icon: "warning",
        text: "Preencha o campo Status para fazer uma pesquisa sem Número Hidrômetro",
      })
      return
    }

    let body = {
      NR_HIDROMETRO: search.number,
      DS_DESCRICAO_HIDROMETRO: search.desc,
      DS_MODELO_HIDROMETRO: search.model,
      TP_ATIVO: search.status,
    }

    api
      .post("/hydrometers/filter", body)
      .then(response => {
        let arr = formatArray(response.data)
        if (arr.length === 0) {
          Swal.fire({
            icon: "warning",
            text: "Nenhum resultado encontrado, refaça a sua busca!",
          })
          setShowList(false)
        } else {
          Swal.fire({
            icon: "success",
            timer: 1000,
          })
          arr.map(elem => {
            if (elem.status === "S") {
              elem.status = "Ativo"
            }
            if (elem.status === "N") {
              elem.status = "Inativo"
            }
          })

          console.log(arr)
          setValues(arr)
          setSearch(initialState)
          setShowList(true)
          setFormattedData(arr)
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "warning",
          text: "Erro Tente Novamente!",
        })
        setShowList(false)
      })
  }

  function verificaleitura(diaLeitura) {
    const hoje = new Date()
    const diaAtual = hoje.getDate()

    let diasRestantes
    if (diaLeitura >= diaAtual) {
      diasRestantes = diaLeitura - diaAtual
    } else {
      const ultimoDiaMes = new Date(
        hoje.getFullYear(),
        hoje.getMonth() + 1,
        0
      ).getDate()
      diasRestantes = ultimoDiaMes - diaAtual + parseInt(diaLeitura)
    }

    if (diasRestantes <= 2) {
      return "red"
    } else if (diasRestantes > 2 && diasRestantes < 5) {
      return "green"
    } else {
      return "none"
    }
  }

  const formatArray = data => {
    let arr = []
    data.map(elem => {
      arr.push({
        id: elem.OID_EMPRESA,
        cnpj: elem.NR_CNPJ,
        razao: elem.NM_RAZAO_SOCIAL,
        cep: elem.CD_CEP,
        telefone: elem.NR_TELEFONE,
        installationDate: null,
        endereco:
          elem.DS_LOGRADOURO +
          ", " +
          elem.NR_LOGRADOURO +
          ", " +
          elem.DS_BAIRRO +
          ".",
        checked: elem.TP_ENVIO === "S" ? true : false,
        log: elem.DS_LOGRADOURO,
        nr: elem.NR_LOGRADOURO,
        bairro: elem.DS_BAIRRO,
        diaLeitura: elem?.NR_DIA_LEITURA ? parseInt(elem.NR_DIA_LEITURA) : 0,
        leituraStatus: verificaleitura(elem.NR_DIA_LEITURA),
      })
    })
    return arr
  }

  const parseInstallationDate = data => {
    if (!data) {
      console.log("parseInstallationDate: data é null/undefined")
      return null
    }

    console.log("parseInstallationDate: data structure:", JSON.stringify(data))

    // Se for um array, extrai o primeiro elemento
    if (Array.isArray(data) && data.length > 0) {
      console.log("É um array! Pegando primeiro elemento:", data[0])
      data = data[0]
    }

    console.log("parseInstallationDate: data.DT_INST_COND =", data.DT_INST_COND)
    console.log("parseInstallationDate: typeof data =", typeof data)

    return (
      data.DT_INST_COND ||
      data.DT_INSTALACAO ||
      data.installationDate ||
      data.dataInstalacao ||
      null
    )
  }



  const formatInstallationDate = value => {
    if (!value) {
      console.log("formatInstallationDate: value é null/undefined/empty")
      return "-"
    }

    console.log("formatInstallationDate input:", value, "typeof:", typeof value)
    const date = new Date(value)
    console.log("Parsed date object:", date)
    console.log("date.getTime():", date.getTime())

    if (Number.isNaN(date.getTime())) {
      console.log("Invalid date detected")
      return "-"
    }

    const formatted = date.toLocaleDateString("pt-BR")
    console.log("Formatted result:", formatted)
    return formatted
  }

  // Convert date to YYYY-MM-DD format for date input
  const convertToDateInputFormat = (value) => {
    if (!value) return ""

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ""

    // Return YYYY-MM-DD format
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  const loadInstallationDates = async arr => {
    const updates = await Promise.all(
      arr.map(async item => {
        try {
          const response = await api.get(
            `/empresa/installation-date/${item.id}`
          )
          console.log("===== INSTALLATION DATE RESPONSE =====")
          console.log("Item ID:", item.id)
          console.log("Full response:", response)
          console.log("response.data:", response.data)
          console.log("response.status:", response.status)
          console.log("=====================================")

          const dateValue = parseInstallationDate(response.data)
          console.log("Final dateValue after parsing:", dateValue)

          return { ...item, installationDate: dateValue }
        } catch (error) {
          console.log("❌ Erro ao carregar data de instalação para", item.id, ":", error)
          return item
        }
      })
    )
    console.log("All installation dates loaded, updates:", updates)
    return updates
  }


  const warning = value => {
    if (value === true) {
      setModalType("sim")
    } else {
      setModalType("nao")
    }

    setPendingRadioValue(value)

    toggle()
  }

  const handleRadioChangecancela = (id, value) => {
    toggle()

    setFormattedData(prevData =>
      prevData.map(item => {
        if (item.id === id) {
          console.log(`Changing radio with id ${id} to value ${value}`)
          return { ...item, checked: value }
        } else {
          return item
        }
      })
    )
    // setPendingRadioValue(null);
  }

  const handleClick = arr => {
    setShowRazao(true)
  }

  const [editModeRow, setEditModeRow] = useState(null)
  const [editModeRowEnd, setEditModeRowEnd] = useState(null)
  const [editedName, setEditedName] = useState("")
  const [editedCnpj, setEditedCnpj] = useState("")
  const [editedLog, setEditedLog] = useState("")
  const [editedNrLog, setEditedNrLog] = useState("")
  const [editedBairro, setEditedBairro] = useState("")
  const [editedDiaLeitura, setEditedDiaLeitura] = useState("")
  const [cores, setCores] = useState({ red: "red", green: "#7CFC00" })


  const handleSave = async arr => {
    setEditModeRow(null)


    let data = {
      NR_CNPJ: editedCnpj,
      NR_LOGRADOURO: editedNrLog,
      DS_LOGRADOURO: editedLog,
      DS_BAIRRO: editedBairro,
      NM_RAZAO_SOCIAL: editedName,
      NR_DIA_LEITURA: editedDiaLeitura != "" ? editedDiaLeitura : null,
    }

    if (editedDiaLeitura != null) {
      if (editedDiaLeitura > 31 || editedDiaLeitura < 1) {
        Swal.fire({
          icon: "warning",
          title: "Erro!",
          text: "O dia de leitura deve ser um número entre 1 e 31",
        })
        return
      }
    }
    try {
      await api.put("/empresa/" + arr.id, data)

      if (editedInstallationDate) {
        // Convert YYYY-MM-DD to ISO format for API
        const dateToSave = new Date(editedInstallationDate).toISOString()
        await api.post(`/empresa/installation-date/${arr.id}`, {
          DT_INST_COND: dateToSave,
        })
      } else {
        await api.delete(`/empresa/installation-date/${arr.id}`)
      }

      Swal.fire({
        icon: "success",
        title: "Dado(s) Alterado(s)!",
      })
        .then(() => {
          navigate("/condominios")
          window.location.reload(true)
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Erro!",
          })
        })
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "Erro!",
      })
    }
  }

  const handleEditClick = arr => {
    setEditedName(arr.razao)
    setEditedCnpj(arr.cnpj)
    setEditedLog(arr.log)
    setEditedNrLog(arr.nr)
    setEditedBairro(arr.bairro)
    setEditedDiaLeitura(arr.diaLeitura)
    setEditedInstallationDate(convertToDateInputFormat(arr.installationDate) || "")
    setEditModeRow(arr)
  }

  const handleEditClickcnpj = arr => {
    setEditedName(arr.razao)
    setEditedCnpj(arr.cnpj)
    setEditedLog(arr.log)
    setEditedNrLog(arr.nr)
    setEditedBairro(arr.bairro)
    setEditedInstallationDate(convertToDateInputFormat(arr.installationDate) || "")
    setEditModeRow(arr)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCores(prevCores => {
        if (prevCores.red === "") {
          return { red: "red", green: "#7CFC00" }
        } else {
          return { red: "", green: "" }
        }
      })
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  const handleRadioChangesim = (id, value) => {
    toggle()

    setFormattedData(prevData =>
      prevData.map(item => {
        if (item.id === id) {
          console.log(`Changing radio with id ${id} to value ${value}`)
          return { ...item, checked: true }
        } else {
          return item
        }
      })
    )
    // setPendingRadioValue(null);
  }

  const handleRadioChange = (id, value) => {
    toggle()
    // setModalType("email");
    // toggle();

    let data = {
      TP_ENVIO: value === true ? "S" : "N",
    }
    api.put("/empresa/" + id, data)

    setFormattedData(prevData =>
      prevData.map(item => {
        if (item.id === id) {
          console.log(`Changing radio with id ${id} to value ${value}`)
          return { ...item, checked: value }
        } else {
          return item
        }
      })
    )
    // setPendingRadioValue(null);
  }

  const handleCheckboxChange = (id, checked) => {
    if (checked === "S") {
      setFormattedData(prevData =>
        prevData.map(item => {
          const updatedItem = item.id === id ? { ...item, checked: "N" } : item
          console.log(`Updated item with id ${id}:`, updatedItem)
          return updatedItem
        })
      )
    } else {
      setFormattedData(prevData =>
        prevData.map(item => {
          const updatedItem = item.id === id ? { ...item, checked: "S" } : item
          console.log(`Updated item with id ${id}:`, updatedItem)
          return updatedItem
        })
      )
    }
    yourFunction(id)
  }

  const handleDeleteClick = async arr => {
    let medidores = await buscarMedidores(arr.id)
    console.log(medidores)
    if (medidores > 0) {
      Swal.fire({
        icon: "warning",
        title: "Erro!",
        text:
          "Esta Empresa possui " +
          medidores +
          " medidores Individualizados cadastrados ",
      })
      return
    }
    Swal.fire({
      title: "Deseja realmente excluir este condomínio?",
      text: "Esta ação não poderá ser revertida!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir!",
      cancelButtonText: "Não",
    }).then(result => {
      if (result.isConfirmed) {
        api
          .delete("/empresa/" + arr.id)
          .then(() => {
            Swal.fire({
              icon: "success",
              title: "Sucesso!",
              text: "Empresa deletada com sucesso",
              timer: 5000,
            }).then(() => {
              window.location.reload(true)
            })
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Erro ao deletar empresa",
              timer: 1000,
            })
          })
      }
    })
  }

  const yourFunction = id => {
    const updatedItem = formattedData.find(item => item.id === id)
    console.log(
      `Checkbox clicked for row with id ${id}. Updated value:`,
      updatedItem.checked
    )
  }

  const buscarMedidores = async id => {
    let body = {
      OID_EMPRESA: id,
    }
    let medidores = 0
    await api.post("/hydrometers/filter/todos", body).then(response => {
      medidores = response.data.length
    })
    return medidores
  }

  const checkboxRef = useRef("")
  const [checkbox, setCheckbox] = useState(false)
  const handleChange = id => {
    setCheckbox(checkboxRef.current.checked)
    console.log(`Checkbox clicked for row with id ${id}.`)
  }

  const removeAccents = str =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()

  return (
    <React.Fragment>
      <div className="page-content">
        <label id="component-title">
          Lista de Condomínios cadastrados | Syskeeper
        </label>

        <form className="component-form container" style={{ margin: "0px" }}>
          <div className="container">
            <Row>
              <label className="col-md-1 col-form-label">Razão</label>
              <div className="col-md-3">
                <input
                  className="form-control"
                  list="datalistOptions"
                  id="exampleDataList"
                  placeholder="Digite para procurar..."
                  onChange={e => setfilterCondominio(e.target.value)}
                  value={filterCondominio}
                />
                {filterCondominio && (
                  <button
                    type="button"
                    className="btn btn-secondary clear-button"
                    onClick={() => setfilterCondominio("")}
                  >
                    Limpar
                  </button>
                )}
                <datalist id="datalistOptions">
                  {uniqueEmpresas
                    .filter(empresa =>
                      removeAccents(empresa).includes(
                        removeAccents(filterCondominio)
                      )
                    )
                    .map((empresa, index) => (
                      <option key={index} value={empresa}>
                        {empresa}
                      </option>
                    ))}
                </datalist>
              </div>

              <label
                className="col-md-1 col-form-label"
                style={{
                  paddingLeft: "4%",
                  paddingBottom: "2%",
                  paddingRight: "0%",
                }}
              >
                End.
              </label>
              <div className="col-md-3">
                <input
                  className="form-control"
                  list="datalistOptions2"
                  id="exampleDataList2"
                  placeholder="Digite para procurar..."
                  onChange={e => setfilterEndereco(e.target.value)}
                  value={filterEndereco}
                />
                {filterEndereco && (
                  <button
                    type="button"
                    className="btn btn-secondary clear-button"
                    onClick={() => setfilterEndereco("")}
                  >
                    Limpar
                  </button>
                )}
                <datalist id="datalistOptions2">
                  {uniqueEnd
                    .filter(empresa =>
                      empresa
                        .toLowerCase()
                        .includes(filterEndereco.toLowerCase())
                    )
                    .map((empresa, index) => (
                      <option key={index} value={empresa}>
                        {empresa}
                      </option>
                    ))}
                </datalist>
              </div>

              <div className="col-md-3">
                <div className="text-sm-end">
                  <Link to="/cadastro/condominio-cadastro">
                    <Button
                      type="button"
                      color="primary"
                      className="btn-rounded  mb-2 me-2"
                    // onClick={handleOrderClicks}
                    >
                      <i className="mdi mdi-plus me-1" />
                      Adicionar
                    </Button>
                  </Link>
                </div>
              </div>
            </Row>

            {/* <div className="row" style={{ textAlign: "end" }}>
              
              <div className="col-6" style={{ alignSelf: "center" }}>
                <Button
                  icon="ti-user"
                  text="Cadastrar Morador"
                  link="/cadastro/moradores-cadastro"
                  
                />
              </div>
            </div> */}
          </div>
        </form>
        {/* <SearchTable
          tableHead={[
            "Nome",
            
            "",
          ]}
          tableBody={[values, 1]}
          showTable={showList}
        >
          {values?.map((maker, key) => (
            <td key={key}>
              <Link
                type="button"
                to={`/cadastro/hidrometro-update/${maker.id}`}
                color="link"
                size="sm"
                className="btn-light waves-effect waves-light"
              >
                <i className="dripicons-document-edit" />
              </Link>
            </td>
          ))}
        </SearchTable> */}
        <div className="condominios-table-wrap" ref={tableWrapRef}>
          <table className="table align-middle mb-0 condominios-table">
            <thead className="table-light">
              <tr>
                <th
                  className="align-middle sorting"
                  onClick={() => changeOrder("cnpj")}
                >
                  <span>
                    CNPJ
                    <img
                      style={{ float: "right", width: "10px", height: "20px" }}
                      src={
                        orderBy != "cnpj"
                          ? inicial
                          : order % 2 === 1
                            ? cima
                            : baixo
                      }
                      alt="Ícone de ordenação"
                    />
                  </span>
                </th>
                <th
                  className="align-middle sorting"
                  onClick={() => changeOrder("razao")}
                >
                  <span>
                    Razão Social
                    <img
                      style={{ float: "right", width: "10px", height: "20px" }}
                      src={
                        orderBy != "razao"
                          ? inicial
                          : order % 2 === 1
                            ? cima
                            : baixo
                      }
                      alt="Ícone de ordenação"
                    />
                  </span>
                </th>
                <th
                  className="align-middle sorting"
                  onClick={() => changeOrder("endereco")}
                >
                  <span>
                    End.
                    <img
                      style={{ float: "right", width: "10px", height: "20px" }}
                      src={
                        orderBy != "endereco"
                          ? inicial
                          : order % 2 === 1
                            ? cima
                            : baixo
                      }
                      alt="Ícone de ordenação"
                    />
                  </span>
                </th>
                <th
                  className="align-middle sorting"
                  onClick={() => changeOrder("diaLeitura")}
                >
                  <span style={{ display: "flex", alignItems: "center" }}>
                    Dia de leitura{" "}
                    <img
                      style={{
                        width: "10px",
                        height: "20px",
                        marginLeft: "5px",
                      }}
                      src={
                        orderBy != "diaLeitura"
                          ? inicial
                          : order % 2 === 1
                            ? cima
                            : baixo
                      }
                      alt="Ícone de ordenação"
                    />
                  </span>
                </th>
                <th
                  className="align-middle sorting"
                  onClick={() => changeOrder("installationDate")}
                >
                  <span style={{ display: "flex", alignItems: "center" }}>
                    Inst. Condo{" "}
                    <img
                      style={{
                        width: "10px",
                        height: "20px",
                        marginLeft: "5px",
                      }}
                      src={
                        orderBy != "installationDate"
                          ? inicial
                          : order % 2 === 1
                            ? cima
                            : baixo
                      }
                      alt="Ícone de ordenação"
                    />
                  </span>
                </th>

                <th
                  className="align-middle sorting"
                  style={{ paddingLeft: "10px" }}
                  onClick={() => changeOrder("cep")}
                >
                  <span>
                    CEP
                    <img
                      style={{ float: "right", width: "10px", height: "20px" }}
                      src={
                        orderBy != "cep"
                          ? inicial
                          : order % 2 === 1
                            ? cima
                            : baixo
                      }
                      alt="Ícone de ordenação"
                    />
                  </span>
                </th>
                <th
                  className="align-middle sorting"
                  onClick={() => changeOrder("status")}
                >
                  <span>
                    Status
                    <img
                      style={{ float: "right", width: "10px", height: "20px" }}
                      src={
                        orderBy != "status"
                          ? inicial
                          : order % 2 === 1
                            ? cima
                            : baixo
                      }
                      alt="Ícone de ordenação"
                    />
                  </span>
                </th>
                {isAdmin && (
                  <th className="align-middle">
                    <span>Síndico</span>
                  </th>
                )}
                <th className="align-middle"></th>
                <th className="sorting">
                  Envio Prefeituras <span className="sort-icon"></span>
                </th>
                <th className="align-middle sorting">
                  Ações <span className="sort-icon"></span>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredShowInfos.length > 0 ? (
                filteredShowInfos?.map((arr, key) => (
                  <tr key={"_tr_" + key}>
                    <td>
                      {(() => {
                        if (editModeRow === arr) {
                          return (
                            <>
                              <ReactInputMask
                                mask="99.999.999/9999-99"
                                type="text"
                                value={editedCnpj}
                                onChange={e => setEditedCnpj(e.target.value)}
                              />
                              <button
                                style={{ marginLeft: "3%" }}
                                className="btn btn-outline-secondary"
                                onClick={() => handleSave(arr)}
                              >
                                Salvar
                              </button>
                            </>
                          )
                        } else {
                          return (
                            <span className="">
                              {arr.cnpj ? arr.cnpj : "00.000.000/00001-00"}
                              <a
                                style={{ left: "5%" }}
                                type="button"
                                onClick={() => handleEditClick(arr)}
                                color="link"
                                size="sm"
                                className="btn btn-light waves-effect waves-light"
                              >
                                <i className="dripicons-document-edit" />
                              </a>
                            </span>
                          )
                        }
                      })()}

                      {/* {arr.cnpj? arr.cnpj : "00.000.000/00001-00"}  */}
                    </td>
                    <td>
                      {(() => {
                        if (editModeRow === arr) {
                          return (
                            <>
                              <input
                                type="text"
                                value={editedName}
                                onChange={e => setEditedName(e.target.value)}
                              />
                              <button
                                style={{ marginLeft: "3%" }}
                                className="btn btn-outline-secondary"
                                onClick={() => handleSave(arr)}
                              >
                                Salvar
                              </button>
                            </>
                          )
                        } else {
                          return (
                            <span className="">
                              {arr.razao}
                              <a
                                style={{ left: "5%" }}
                                type="button"
                                onClick={() => handleEditClick(arr)}
                                color="link"
                                size="sm"
                                className="btn btn-light waves-effect waves-light"
                              >
                                <i className="dripicons-document-edit" />
                              </a>
                            </span>
                          )
                        }
                      })()}
                    </td>
                    <td>
                      {(() => {
                        if (editModeRow === arr) {
                          return (
                            <>
                              <input
                                type="text"
                                value={editedLog}
                                onChange={e => setEditedLog(e.target.value)}
                              />
                              <input
                                type="text"
                                value={editedNrLog}
                                style={{ maxWidth: "80px" }}
                                onChange={e => setEditedNrLog(e.target.value)}
                              />
                              <input
                                type="text"
                                value={editedBairro}
                                onChange={e => setEditedBairro(e.target.value)}
                              />

                              <button
                                style={{ marginLeft: "3%" }}
                                className="btn btn-outline-secondary"
                                onClick={() => handleSave(arr)}
                              >
                                Salvar
                              </button>
                            </>
                          )
                        } else {
                          return (
                            <span className="">
                              {arr.endereco}
                              <a
                                style={{ left: "5%" }}
                                type="button"
                                onClick={() => handleEditClick(arr)}
                                color="link"
                                size="sm"
                                className="btn btn-light waves-effect waves-light"
                              >
                                <i className="dripicons-document-edit" />
                              </a>
                            </span>
                          )
                        }
                      })()}
                    </td>
                    <td className="text-end">
                      {(() => {
                        if (editModeRow === arr) {
                          return (
                            <>
                              <input
                                type="number"
                                value={editedDiaLeitura}
                                max={31}
                                min={1}
                                onChange={e =>
                                  setEditedDiaLeitura(e.target.value)
                                }
                              />
                              <button
                                style={{ marginLeft: "3%" }}
                                className="btn btn-outline-secondary"
                                onClick={() => handleSave(arr)}
                              >
                                Salvar
                              </button>
                            </>
                          )
                        } else {
                          return (
                            <span className="">
                              <b
                                style={{
                                  backgroundColor: cores[arr.leituraStatus],
                                  padding: "10px",
                                  borderRadius: "5px",
                                }}
                              >
                                {arr.diaLeitura}
                              </b>
                              <a
                                style={{ left: "5%" }}
                                type="button"
                                onClick={() => handleEditClick(arr)}
                                color="link"
                                size="sm"
                                className="btn btn-light waves-effect waves-light"
                              >
                                <i className="dripicons-document-edit" />
                              </a>
                            </span>
                          )
                        }
                      })()}
                    </td>
                    <td>
                      {(() => {
                        if (editModeRow === arr) {
                          return (
                            <>
                              <input
                                type="date"
                                value={editedInstallationDate || ""}
                                onChange={e =>
                                  setEditedInstallationDate(e.target.value)
                                }
                              />
                              <button
                                style={{ marginLeft: "3%" }}
                                className="btn btn-outline-secondary"
                                onClick={() => handleSave(arr)}
                              >
                                Salvar
                              </button>
                            </>
                          )
                        }

                        return (
                          <span className="">
                            {formatInstallationDate(arr.installationDate)}
                            <a
                              style={{ left: "5%" }}
                              type="button"
                              onClick={() => handleEditClick(arr)}
                              color="link"
                              size="sm"
                              className="btn btn-light waves-effect waves-light"
                            >
                              <i className="dripicons-document-edit" />
                            </a>
                          </span>
                        )
                      })()}
                    </td>

                    <td style={{ paddingLeft: "10px" }}>{arr.cep}</td>

                    <td>
                      {arr.status == null ? (
                        <span className="badge bg-success">
                          Cadastro Completo
                        </span>
                      ) : (
                        <span className="badge bg-danger bg-primary">
                          Cadastro Incompleto
                        </span>
                      )}
                    </td>
                    {isAdmin && (
                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <span style={{ fontSize: "12px" }}>
                            {sindicosMap[arr.id] ? sindicosMap[arr.id].nome : "Sem síndico"}
                          </span>
                          <Button
                            size="sm"
                            color="info"
                            onClick={() => openSindicoModal(arr)}
                            title="Gerenciar Síndico"
                          >
                            <i className="dripicons-user" />
                          </Button>
                        </div>
                      </td>
                    )}
                    {/* <td>
											<Link
												type="button"
												to={``}
												color="link"
												size="sm"
												className="btn-light waves-effect waves-light"
											>
												<i className="dripicons-document-edit" />
											</Link>
										</td> */}
                    <td>
                      <Link
                        type="button"
                        to={`/listaMoradores/${arr.id}/`}
                        color="primary"
                        size="sm"
                        className="btn btn-primary waves-effect waves-light btn-rounded"
                      >
                        Ver Moradores
                      </Link>
                    </td>
                    {/* <td>
                          <input
                            type="checkbox"
                            id={arr.id}
                            checked={arr.checked === "S"? "checked" : null}
                             onChange={() => handleCheckboxChange(arr.id,arr.checked)}
                          />{arr.checked}
                        </td> */}
                    <td>
                      <input
                        type="radio"
                        className="btn-check"
                        name={`btnradio_${arr.id}`}
                        id={`btnradio4_${arr.id}`}
                        autoComplete="off"
                        checked={arr.checked === true}
                        // onChange={() => handleRadioChange(arr.id, true)}
                        onClick={() => {
                          setModalType("sim")
                          toggle()
                          setUserData(arr)
                          warning(true)
                        }}
                      />
                      <label
                        className="btn btn-outline-secondary"
                        htmlFor={`btnradio4_${arr.id}`}
                      >
                        Sim
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name={`btnradio_${arr.id}`}
                        id={`btnradio5_${arr.id}`}
                        autoComplete="off"
                        checked={arr.checked === false}
                        onClick={() => {
                          setModalType("sim")
                          toggle()
                          setUserData(arr)
                          warning(false)
                        }}
                      // onChange={() => handleRadioChange(arr.id, false)}
                      />
                      <label
                        className="btn btn-outline-secondary"
                        htmlFor={`btnradio5_${arr.id}`}
                      >
                        Não
                      </label>
                    </td>
                    <td>
                      {(() => {
                        if (editModeRow === arr) {

                          return (
                            <>
                              <button
                                style={{ marginLeft: "3%" }}
                                className="btn btn-outline-secondary"
                                onClick={() => setEditModeRow(null)}
                              >
                                Voltar
                              </button>
                              <button
                                style={{ marginLeft: "3%" }}
                                className="btn btn-outline-secondary"
                                onClick={() => handleSave(arr)}
                              >
                                Salvar
                              </button>
                            </>
                          )
                        } else {
                          return (
                            <span className="">
                              <a
                                style={{ left: "5%" }}
                                type="button"
                                onClick={() => handleEditClick(arr)}
                                color="link"
                                size="sm"
                                className="btn btn-light waves-effect waves-light"
                              >
                                <i className="dripicons-document-edit" />
                              </a>
                              <a
                                style={{ left: "5%" }}
                                type="button"
                                onClick={() => handleDeleteClick(arr)}
                                color="link"
                                size="sm"
                                className="btn btn-light waves-effect waves-light"
                              >
                                <i
                                  className="dripicons-trash"
                                  style={{ color: "red" }}
                                />
                              </a>

                            </span>
                          )
                        }
                      })()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>Nenhum Registro </td>
                </tr>
              )}
            </tbody>
          </table>
          <Modal isOpen={modal} toggle={toggle} style={{ paddingTop: "15%" }}>
            <ModalHeader toggle={toggle}>
              {modalType == "sim" ? <>Confirmar Ação</> : <></>}
              {modalType == "nao" ? <>Confirmar Ação</> : <></>}
            </ModalHeader>
            <ModalBody>
              {modalType == "sim" ? (
                <>
                  {passwordEntered ? (
                    <>
                      <h3>
                        Deseja Confirmar o status de envio de {userData.razao}{" "}
                        para SIM?
                      </h3>
                      <div className="btn-lg d-flex justify-content-center mt-3">
                        <Button
                          color="danger"
                          className="btn btn-danger waves-effect waves-light"
                          onClick={() => {
                            handleRadioChange(userData.id, true)
                          }}
                        >
                          Confirmar
                        </Button>

                        <Button
                          color="primary"
                          className="btn-lg mx-2"
                          type="submit"
                          onClick={() => {
                            handleRadioChangecancela(userData.id, false)
                          }}
                        >
                          Voltar
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="password-input">
                        <Input
                          type="password"
                          placeholder="Senha"
                          value={password}
                          onChange={handlePasswordChange}
                        />
                        {/* <button className="confirm-button" onClick={handlePasswordSubmit} >Entrar</button> */}
                        {/* <button onClick={handlePasswordSubmit}>Submit</button> */}
                      </div>
                      <div style={{ margin: "5px" }}>
                        <button
                          className="confirm-button"
                          onClick={handlePasswordSubmit}
                        >
                          Entrar
                        </button>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <></>
              )}

              {modalType == "nao" ? (
                <>
                  {passwordEntered ? (
                    <>
                      <h3>
                        Deseja Confirmar o status de envio de {userData.razao}{" "}
                        para NÂO?
                      </h3>
                      <div className="btn-lg d-flex justify-content-center mt-3">
                        <Button
                          color="danger"
                          className="btn btn-danger waves-effect waves-light"
                          onClick={() => {
                            handleRadioChange(userData.id, false)
                          }}
                        >
                          Confirmar
                        </Button>

                        <Button
                          color="primary"
                          className="btn-lg mx-2"
                          type="submit"
                          onClick={() => {
                            handleRadioChangecancela(userData.id, true)
                          }}
                        >
                          Voltar
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="password-input">
                        <Input
                          type="password"
                          placeholder="Senha"
                          value={password}
                          onChange={handlePasswordChange}
                        />
                        {/* <button className="confirm-button" onClick={handlePasswordSubmit} >Entrar</button> */}
                        {/* <button onClick={handlePasswordSubmit}>Submit</button> */}
                      </div>
                      <div style={{ margin: "5px" }}>
                        <button
                          className="confirm-button"
                          onClick={handlePasswordSubmit}
                        >
                          Entrar
                        </button>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
              {modalType == "deletar" ? (
                <>
                  {load ? (
                    <>Aguarde..</>
                  ) : (
                    <>
                      {validDelete ? (
                        <>
                          <h3>Deseja deletar a empresa ?</h3>
                          <br></br>
                          <div className="btn-lg d-flex justify-content-center mt-3">
                            <Button
                              color="primary"
                              className="btn-lg mx-2"
                              type="submit"
                            >
                              Confirmar
                            </Button>
                            <Button
                              color="primary"
                              className="btn-lg mx-2"
                              type="submit"
                              onClick={() => {
                                toggle()
                              }}
                            >
                              Cancelar
                            </Button>
                          </div>
                        </>
                      ) : (
                        <>
                          {" "}
                          <h3>
                            Esta Empresa possuir HD Individualizados cadastrados{" "}
                          </h3>{" "}
                          <br></br>
                          <div className="btn-lg d-flex justify-content-center mt-3">
                            <Button
                              color="primary"
                              className="btn-lg mx-2"
                              type="submit"
                              onClick={() => {
                                toggle()
                              }}
                            >
                              Entendido
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
            </ModalBody>
          </Modal>

          {/* Modal para gerenciar síndico */}
          <Modal isOpen={modalSindico} toggle={() => setModalSindico(!modalSindico)} size="md">
            <ModalHeader toggle={() => setModalSindico(!modalSindico)}>
              Gerenciar Síndico - {selectedCondo?.razao}
            </ModalHeader>
            <ModalBody>
              <div className="mb-3">
                <label className="form-label">Selecione o síndico</label>
                <Select
                  options={sindicos}
                  value={selectedSindico}
                  onChange={setSelectedSindico}
                  placeholder="Selecione um síndico..."
                  isClearable={false}
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: "#fff",
                    }),
                    menu: (base) => ({
                      ...base,
                      backgroundColor: "#fff",
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused ? "#e0dcdc" : "#fff",
                      color: "#000",
                    }),
                  }}
                />
                {sindicosMap[selectedCondo?.id] && (
                  <small className="text-muted mt-2 d-block">
                    Síndico atual: <strong>{sindicosMap[selectedCondo?.id]?.nome}</strong> ({sindicosMap[selectedCondo?.id]?.email})
                  </small>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setModalSindico(false)}>
                Cancelar
              </Button>
              <Button color="primary" onClick={saveSindicoVinculo}>
                Salvar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Condominios
